import { useEffect } from "react";
import { usePatchPortfolioLeasingMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioLeasingMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getLeasingFormSchema } from "web_myplann/Portfolio/Forms/LeasingForm/leasingFormSchema";
import { mapPortfolioToLeasingForm } from "web_myplann/Portfolio/Forms/LeasingForm/mapPortfolioToLeasingForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditLeasingFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditLeasingForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditLeasingFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPortfolioLeasingMutation(portfolioId);

	const { form, onSubmit, leaveConfirmation } = useEditPortfolioForm({
		schema: getLeasingFormSchema(t, {
			lockKeyFields: !portfolio.allowKeyPropertiesEditByClient,
		}),
		defaultValues: mapPortfolioToLeasingForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
		isPending,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending, leaveConfirmation };
};
